import { Box, Theme, Typography, useMediaQuery } from '@mui/material';
import Image from 'next/image';
import { FormattedMessage } from 'react-intl';

import { SiteLocale } from 'constants/i18n.constants';
import { brandConfig } from 'constants/saudi-rewards.constants';
import { useLocale } from 'hooks/useLocale';

import {
  GradientImage,
  NoiseImage,
} from 'components/@loyalty/Card/Card.styles';
import LandscapeCardContainer from 'components/@loyalty/LandscapeCardContainer';

interface Props {
  saudiRewardsMemberId?: string;
  size?: 'small' | 'medium';
}

const SaudiRewardsCardLandscape = ({
  saudiRewardsMemberId,
  size = 'medium',
}: Props) => {
  const { locale } = useLocale();
  const isMobile = useMediaQuery<Theme>((theme) =>
    theme.breakpoints.down('md'),
  );

  return (
    <LandscapeCardContainer
      backgroundColor={brandConfig.backgroundColor}
      borderColor={brandConfig.borderColor}
      mixBlendMode={brandConfig.mixBlendMode}
      size={size}
    >
      <GradientImage variant="landscape" />
      <Box
        sx={{
          position: 'absolute',
          width: '100%',
          height: '100%',
          backgroundColor: brandConfig.subLayer,
          mixBlendMode: 'soft-light',
          // Design says 0.3, but figma gives a different constract with blend modes, hence we use 0.5 in code.
          opacity: 0.5,
        }}
      />
      <NoiseImage variant="landscape" />

      <Image
        src={
          locale === SiteLocale.EN
            ? '/images/saudi-rewards/logo_saudirewards-en.webp'
            : '/images/saudi-rewards/logo_saudirewards-ar.webp'
        }
        height={size === 'small' ? (isMobile ? 31 : 56) : 56}
        width={size === 'small' ? (isMobile ? 72 : 132) : 132}
        style={{ objectFit: 'contain', mixBlendMode: 'screen' }}
        alt="Saudi Rewards logo"
        priority
        unoptimized
      />
      {!!saudiRewardsMemberId && (
        <Box sx={{ position: 'absolute', bottom: 24 }}>
          <Typography
            sx={{
              color: brandConfig.gradient.start,
              mixBlendMode: 'screen',
              opacity: 0.7,
            }}
          >
            <FormattedMessage id="account.loyalty.card.member_id" />{' '}
            {saudiRewardsMemberId}
          </Typography>
        </Box>
      )}
    </LandscapeCardContainer>
  );
};

export default SaudiRewardsCardLandscape;
